import { render } from "./accordion.vue?vue&type=template&id=7e0a5b22"
import script from "./accordion.vue?vue&type=script&lang=js"
export * from "./accordion.vue?vue&type=script&lang=js"

import "./accordion.vue?vue&type=style&index=0&id=7e0a5b22&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__